export default {
  productsFavorite: null,
  errorAddproductToFavorite: false,
  msgErrorAddProductToFavorite: '',
  event_id_fb: '',
}
